import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const successCheckStyles: moduleStyleType = {
    checkMark: {
        color: 'success.light',
        marginLeft: '0px',
    },
}
